import { z } from 'zod'

import { apiRequest } from '@/api/client'

const adminSchema = z.object({
  id: z.number(),
  username: z.string(),
  email: z.string(),
  full_name: z.string(),
  whatsapp_number: z.string().nullable().optional(),
  business_name: z.string().nullable().optional(),
  role: z.literal('admin').or(z.string()),
  is_active: z.boolean(),
  created_at: z.string().nullable().optional(),
  updated_at: z.string().nullable().optional(),
})

export type AdminAccount = z.infer<typeof adminSchema>

export type AdminUpsertPayload = {
  username: string
  email: string
  full_name: string
  whatsapp_number?: string | null
  is_active?: boolean
}

const passwordResetSchema = z.object({
  user_id: z.number().optional(),
  email: z.string(),
  emailed: z.boolean(),
  reset_url: z.string().nullable().optional(),
  expires_hours: z.number(),
  role: z.string().optional(),
})

export type AdminPasswordResetResult = z.infer<typeof passwordResetSchema>

export function fetchAdminAdmins() {
  return apiRequest('/api/v1/admins/admin', (data) =>
    z.object({ admins: z.array(adminSchema) }).parse(data),
  )
}

export function createAdminAdmin(payload: AdminUpsertPayload) {
  return apiRequest('/api/v1/admins/admin', (data) => z.object({ admin: adminSchema }).parse(data), {
    method: 'POST',
    body: payload,
  })
}

export function updateAdminAdmin(id: number, payload: AdminUpsertPayload) {
  return apiRequest(`/api/v1/admins/admin/${id}`, (data) => z.object({ admin: adminSchema }).parse(data), {
    method: 'PATCH',
    body: payload,
  })
}

export function setAdminAdminActive(id: number, is_active: boolean) {
  return apiRequest(
    `/api/v1/admins/admin/${id}/active`,
    (data) => z.object({ admin: adminSchema }).parse(data),
    {
      method: 'PATCH',
      body: { is_active },
    },
  )
}

export function sendAdminAdminPasswordReset(id: number) {
  return apiRequest(`/api/v1/admins/admin/${id}/password-reset`, (data) => passwordResetSchema.parse(data), {
    method: 'POST',
    body: {},
  })
}
